import React from 'react'

import { t } from 'src/translations'

import { FilterOptionRows } from './FilterOptionRows'
import {
  FilterVariant,
  filterName,
  getCountryDisplayName,
  sortCountryCodesByDisplayName
} from '../filterUtils'

export type CountriesOfOriginFilterProps = {
  countryCodes: string[]
  variant: FilterVariant
  hasEntered: boolean
  selectedCountriesOfOrigin: string[]
  handleCountryToggle: (countryCode: string) => void
}

export const CountriesOfOriginFilter = ({
  countryCodes,
  variant,
  hasEntered,
  selectedCountriesOfOrigin,
  handleCountryToggle
}: CountriesOfOriginFilterProps) => (
  <FilterOptionRows
    sectionName={t('filters.countries-of-origin')}
    name={filterName(variant, 'countries-of-origin')}
    hasEntered={hasEntered}
    values={sortCountryCodesByDisplayName(countryCodes).map((code) => ({
      id: code,
      name: getCountryDisplayName(code)
    }))}
    selectedValues={new Set(selectedCountriesOfOrigin)}
    onToggle={(code) => handleCountryToggle(code)}
  />
)
